export const getLocale = ({ root }) => root.app.locale;
